import * as React from "react";
import * as Noty from "noty";
import { RioAutoCompleteResult, RioValidator, RioResources, RioIconButton, RioApiPost, RioApiGet, RioIf, RioExpandingPanel, RioModal} from "rio.react.all"
import { AutoComplete } from "../components/AutoComplete";



interface ICampaignPDFDownloadModalProps {
    campaignId: number;
    onClose: () => void;
}

interface ICampaignPDFDownloadModalState {
    searchText: string;
    customerAccountNo: string;
    validationError: string;
}

export class CampaignPDFDownloadModal extends React.Component<ICampaignPDFDownloadModalProps, ICampaignPDFDownloadModalState> {
    constructor(props: Readonly<ICampaignPDFDownloadModalProps>) {
        super(props);

        this.state = {
            searchText: "",
            customerAccountNo: "",
            validationError: ""
        }
    }

    private validator = new RioValidator();

    render() {
        return (
            <React.Fragment>
                <RioModal visible={true} onCancel={() => this.props.onClose()} backgroundClickDisabled={true}>

                    <RioExpandingPanel resource={RioResources.find("DownloadPDF")} expandedDefault={true} disableToggle={true}>
                        <div className="col-6 col-s-12 no-padding">
                            <div className="form-row">
                                <label className="quickFind">{RioResources.find("QuickFind").text}</label>
                                <AutoComplete
                                    value={this.state.customerAccountNo}
                                    onValueChanged={value => this.setState({ customerAccountNo: value })}
                                    onGetOptions={text => this.handleGetOptionsForCustomer(text)}
                                    onGetText={(accountNo) => this.handleGetTextForCustomer(accountNo)}
                                    suggestionMinimumChars={3}
                                />
                                <RioIf condition={!!this.state.validationError} then={
                                    <div className="col-6 col-s-12 no-padding">
                                        <label className="blank"></label>
                                        <div className="fileNotFoundError">{this.state.validationError}</div>
                                    </div>
                                } />
                            </div>
                            
                        </div>
                        


                    </RioExpandingPanel>

                    <div className="buttons emailComposerButtons">
                        <RioIf condition={!!this.state.customerAccountNo} then={
                            <RioIconButton resource={RioResources.find("Download")} onClick={() => this.downloadPDF()} hasPermission={true} />
                        }/>
                        <RioIconButton resource={RioResources.find("Cancel")} onClick={() => this.props.onClose()} hasPermission={true} />
                    </div>

                </RioModal>

            </React.Fragment>
        );
    }

    componentDidMount(): void {

    }

    handleGetOptionsForCustomer(text: string): Promise<Array<RioAutoCompleteResult>> {
        return new Promise<Array<RioAutoCompleteResult>>((resolve, reject) => {
            var call = new RioApiGet<Array<CustomerApiModel>>(`api/Customer/CampaignEmailCustomerQuickSearch/${text}/${this.props.campaignId}`);
            call.onDone = response => {
                if (response.success) {
                    let results: Array<RioAutoCompleteResult> = [];
                    response.item.forEach(searchResult => {
                        let result = new RioAutoCompleteResult();
                        result.value = searchResult.accountNo;
                        result.label = searchResult.accountNo + " - " + searchResult.name;
                        results.push(result);
                    });
                    resolve(results);
                } else {
                    reject();
                }
            }
            call.send();
        });
    }

    handleGetTextForCustomer(accountNo: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!!accountNo) {
                var call = new RioApiGet<CustomerApiModel>(`/api/Customer/Get/${accountNo}`);
                call.onDone = response => {
                    if (response.success) {
                        resolve(response.item.accountNo + " - " + response.item.name);
                        this.setState({
                            validationError: ""
                        });
                    } else {
                        reject();
                    }
                }
                call.send();
            }
        });
    }

    downloadPDF() {
        const call = new RioApiGet<null>(`/api/CampaignEmail/DownloadPDF/${this.props.campaignId}/${this.state.customerAccountNo}`);
        call.onDone = response => {
            if (!response.success) {
                if (response.statusCode == 404) {
                    this.setState({
                        validationError: RioResources.find("CustomerReservePDFNotFound").text
                    });

                }
            }
        }
        call.sendAndGetFile();
    }
}